module.exports = __webpack_public_path__ + "assets/img/projects_item4.2993f18e.png";